const CSV_SEPARATOR = ',';
const CSV_EOL = '\r\n';
const UTF8_BOM = '\uFEFF';

const GROUP_SEPARATORS = /[\u00A0\u2002\u2003\u2007\u2008\u2009\u202F]/g;

const RISKY_PREFIX = /^[=+\-@\t\r]/;
const NUMERIC = /^-?\d+(\.\d+)?$/;

export const stripGroupSeparators = (value: string | undefined | null): string => {
    if (value === undefined || value === null) {
        return '';
    }
    return value.replace(GROUP_SEPARATORS, '');
};

export const csvEscape = (value: unknown): string => {
    const raw = value === undefined || value === null ? '' : String(value);
    const guarded = RISKY_PREFIX.test(raw) && !NUMERIC.test(raw) ? `'${raw}` : raw;
    return `"${guarded.replace(/"/g, '""')}"`;
};

export const csvRow = (cells: unknown[]): string => cells.map(csvEscape).join(CSV_SEPARATOR);

export const csvHeader = (headers: string[]): string => UTF8_BOM + csvRow(headers);

export const joinCsvLines = (lines: string[]): string => lines.join(CSV_EOL) + CSV_EOL;

export const buildCsv = (headers: string[], rows: unknown[][]): string =>
    joinCsvLines([csvHeader(headers), ...rows.map(csvRow)]);
